import { Box, Container, Button, TextField, Grid, Card, CardContent, Typography, CircularProgress, Divider } from "@mui/material";
import { SettingsSuggestOutlined, SaveOutlined } from "@mui/icons-material";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import React, { useEffect, useState } from "react";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF", marginBottom: "24px" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

function Setting() {
    const [setting, setSetting] = useState();
    const [load, setLoad] = useState(true);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        if (load === true) {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
                setSetting(res.data.data[0]);
                setLoad(false);
            });
        }
    }, [load]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true);
        const formData = {
            id: setting?._id,
            aff: Number(e.target.aff.value),
            mb_lo2: Number(e.target.mb_lo2.value),
            mb_lo2dau: Number(e.target.mb_lo2dau.value),
            mb_lo3: Number(e.target.mb_lo3.value),
            mb_lo4: Number(e.target.mb_lo4.value),
            mb_loxien2: Number(e.target.mb_loxien2.value),
            mb_loxien3: Number(e.target.mb_loxien3.value),
            mb_loxien4: Number(e.target.mb_loxien4.value),
            mb_dedb: Number(e.target.mb_dedb.value),
            mb_dedaudb: Number(e.target.mb_dedaudb.value),
            mb_degiai7: Number(e.target.mb_degiai7.value),
            mb_de1: Number(e.target.mb_de1.value),
            mb_dedau1: Number(e.target.mb_dedau1.value),
            mb_dau: Number(e.target.mb_dau.value),
            mb_duoi: Number(e.target.mb_duoi.value),
            mb_3cangdau: Number(e.target.mb_3cangdau.value),
            mb_3cangdb: Number(e.target.mb_3cangdb.value),
            mb_3cang1: Number(e.target.mb_3cang1.value),
            mb_3cangdauduoi: Number(e.target.mb_3cangdauduoi.value),
            mb_4cangdb: Number(e.target.mb_4cangdb.value),
            mb_truotxien4: Number(e.target.mb_truotxien4.value),
            mb_truotxien8: Number(e.target.mb_truotxien8.value),
            mb_truotxien10: Number(e.target.mb_truotxien10.value),
            mb_lo2so1k: Number(e.target.mb_lo2so1k.value),
            
            mt_lo2: Number(e.target.mt_lo2.value),
            mt_lo2dau: Number(e.target.mt_lo2dau.value),
            mt_lo3: Number(e.target.mt_lo3.value),
            mt_lo4: Number(e.target.mt_lo4.value),
            mt_loxien2: Number(e.target.mt_loxien2.value),
            mt_loxien3: Number(e.target.mt_loxien3.value),
            mt_loxien4: Number(e.target.mt_loxien4.value),
            mt_dedb: Number(e.target.mt_dedb.value),
            mt_dedaudb: Number(e.target.mt_dedaudb.value),
            mt_degiai7: Number(e.target.mt_degiai7.value),
            mt_de1: Number(e.target.mt_de1.value),
            mt_dedau1: Number(e.target.mt_dedau1.value),
            mt_dedauduoi: Number(e.target.mt_dedauduoi.value),
            mt_dau: Number(e.target.mt_dau.value),
            mt_duoi: Number(e.target.mt_duoi.value),
            mt_3cangdau: Number(e.target.mt_3cangdau.value),
            mt_3cangdb: Number(e.target.mt_3cangdb.value),
            mt_3cang1: Number(e.target.mt_3cang1.value),
            mt_3cangdauduoi: Number(e.target.mt_3cangdauduoi.value),
            mt_4cangdb: Number(e.target.mt_4cangdb.value),
            mt_truotxien4: Number(e.target.mt_truotxien4.value),
            mt_truotxien8: Number(e.target.mt_truotxien8.value),
            mt_truotxien10: Number(e.target.mt_truotxien10.value),
            mt_lo2so1k: Number(e.target.mt_lo2so1k.value),
            
            mn_lo2: Number(e.target.mn_lo2.value),
            mn_lo2dau: Number(e.target.mn_lo2dau.value),
            mn_lo3: Number(e.target.mn_lo3.value),
            mn_lo4: Number(e.target.mn_lo4.value),
            mn_loxien2: Number(e.target.mn_loxien2.value),
            mn_loxien3: Number(e.target.mn_loxien3.value),
            mn_loxien4: Number(e.target.mn_loxien4.value),
            mn_dedb: Number(e.target.mn_dedb.value),
            mn_dedaudb: Number(e.target.mn_dedaudb.value),
            mn_degiai7: Number(e.target.mn_degiai7.value),
            mn_de1: Number(e.target.mn_de1.value),
            mn_dedau1: Number(e.target.mn_dedau1.value),
            mn_dedauduoi: Number(e.target.mn_dedauduoi.value),
            mn_dau: Number(e.target.mn_dau.value),
            mn_duoi: Number(e.target.mn_duoi.value),
            mn_3cangdau: Number(e.target.mn_3cangdau.value),
            mn_3cangdb: Number(e.target.mn_3cangdb.value),
            mn_3cang1: Number(e.target.mn_3cang1.value),
            mn_3cangdauduoi: Number(e.target.mn_3cangdauduoi.value),
            mn_4cangdb: Number(e.target.mn_4cangdb.value),
            mn_truotxien4: Number(e.target.mn_truotxien4.value),
            mn_truotxien8: Number(e.target.mn_truotxien8.value),
            mn_truotxien10: Number(e.target.mn_truotxien10.value),
            mn_lo2so1k: Number(e.target.mn_lo2so1k.value),
            
            xsn_lo2: Number(e.target.xsn_lo2.value),
            xsn_lo2dau: Number(e.target.xsn_lo2dau.value),
            xsn_lo3: Number(e.target.xsn_lo3.value),
            xsn_lo4: Number(e.target.xsn_lo4.value),
            xsn_loxien2: Number(e.target.xsn_loxien2.value),
            xsn_loxien3: Number(e.target.xsn_loxien3.value),
            xsn_loxien4: Number(e.target.xsn_loxien4.value),
            xsn_dedb: Number(e.target.xsn_dedb.value),
            xsn_dedaudb: Number(e.target.xsn_dedaudb.value),
            xsn_degiai7: Number(e.target.xsn_degiai7.value),
            xsn_de1: Number(e.target.xsn_de1.value),
            xsn_dedau1: Number(e.target.xsn_dedau1.value),
            xsn_dau: Number(e.target.xsn_dau.value),
            xsn_duoi: Number(e.target.xsn_duoi.value),
            xsn_3cangdau: Number(e.target.xsn_3cangdau.value),
            xsn_3cangdb: Number(e.target.xsn_3cangdb.value),
            xsn_3cang1: Number(e.target.xsn_3cang1.value),
            xsn_3cangdauduoi: Number(e.target.xsn_3cangdauduoi.value),
            xsn_4cangdb: Number(e.target.xsn_4cangdb.value),
            xsn_truotxien4: Number(e.target.xsn_truotxien4.value),
            xsn_truotxien8: Number(e.target.xsn_truotxien8.value),
            xsn_truotxien10: Number(e.target.xsn_truotxien10.value),
            xsn_lo2so1k: Number(e.target.xsn_lo2so1k.value),
            
            xd_chan: Number(e.target.xd_chan.value),
            xd_le: Number(e.target.xd_le.value),
            xd_3trang: Number(e.target.xd_3trang.value),
            xd_3do: Number(e.target.xd_3do.value),
            xd_4trang: Number(e.target.xd_4trang.value),
            xd_4do: Number(e.target.xd_4do.value),
            
            tx_c: Number(e.target.tx_c.value),
            tx_l: Number(e.target.tx_l.value),
            tx_t: Number(e.target.tx_t.value),
            tx_x: Number(e.target.tx_x.value),
            
            txmd5_t: Number(e.target.txmd5_t.value),
            txmd5_x: Number(e.target.txmd5_x.value),
            
            kmnapdau: Number(e.target.kmnapdau.value),
            mp3: e.target.mp3.value,
            
            greedy: {
                open: Number(e.target.open.value),
                auto: Number(e.target.auto.value),
                tyle1: Number(e.target.tyle1.value),
                tyle2: Number(e.target.tyle2.value),
                tyle3: Number(e.target.tyle3.value),
                tyle4: Number(e.target.tyle4.value),
                tyle5: Number(e.target.tyle5.value),
                tyle6: Number(e.target.tyle6.value),
                tyle7: Number(e.target.tyle7.value),
                tyle8: Number(e.target.tyle8.value),
                thuong1: Number(e.target.thuong1.value),
                thuong2: Number(e.target.thuong2.value),
                thuong3: Number(e.target.thuong3.value),
                thuong4: Number(e.target.thuong4.value),
                thuong5: Number(e.target.thuong5.value),
                thuong6: Number(e.target.thuong6.value),
                thuong7: Number(e.target.thuong7.value),
                thuong8: Number(e.target.thuong8.value),
                thuong9: Number(e.target.thuong9.value),
                thuong10: Number(e.target.thuong10.value)
            },
            catdog: {
                open: Number(e.target.cd_open.value),
                thuong1: Number(e.target.cd_thuong1.value),
                thuong2: Number(e.target.cd_thuong2.value),
                thuong3: Number(e.target.cd_thuong3.value),
                thuong4: Number(e.target.cd_thuong4.value),
                thuong5: Number(e.target.cd_thuong5.value)
            }
        };

        axios.put(`${process.env.REACT_APP_API_URL}/setting/update`, formData)
            .then((res) => {
                setLoad(false);
                swal(t('success'), "Đã lưu cài đặt tỷ lệ!", "success");
            })
            .catch(() => {
                setLoad(false);
                swal(t('error'), "Có lỗi xảy ra", "error");
            });
    };

    // Component tạo ô nhập liệu chuẩn (Tự chia Grid linh hoạt)
    const SettingInput = ({ label, name, defaultValue, width = {xs: 12, sm: 6, md: 4, lg: 3}, isRed = false, highlightColor }) => (
        <Grid item {...width}>
            <Typography variant="caption" fontWeight="800" color={isRed ? "#F1416C" : "#7E8299"} mb={1} display="flex" alignItems="center" gap={0.5} textTransform="uppercase">
                {highlightColor && <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: highlightColor }} />}
                {label}
            </Typography>
            <TextField 
                fullWidth 
                name={name} 
                id={name} 
                type="number" 
                step="any"
                defaultValue={defaultValue ?? ""} 
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: '#F9F9F9',
                        height: '42px',
                        '& fieldset': { borderColor: '#E4E6EF' },
                        '&:hover fieldset': { borderColor: '#B5B5C3' },
                        '&.Mui-focused fieldset': { borderColor: highlightColor || (isRed ? '#F1416C' : '#1B84FF'), borderWidth: '1px' },
                    },
                    '& .MuiInputBase-input': { 
                        height: '42px', padding: '0 14px', boxSizing: 'border-box',
                        fontSize: '0.9rem', color: '#181C32', fontWeight: 600
                    }
                }} 
            />
        </Grid>
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-setting-zone * { font-family: 'Plus Jakarta Sans', sans-serif !important; }
                    `}</style>

                    <Box className="safe-setting-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        
                        {load && (
                            <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' }}>
                                <CircularProgress size={50} sx={{ color: '#1B84FF' }} />
                            </Box>
                        )}

                        <Container maxWidth="xl">
                            
                            {/* HEADER */}
                            <Box mb={4} display="flex" alignItems="center" gap={1.5}>
                                <SettingsSuggestOutlined sx={{ fontSize: '2.5rem', color: '#1B84FF' }} />
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">{t("setting_rate")}</Typography>
                                    <Typography variant="body2" color="text.secondary">Thiết lập tỷ lệ trả thưởng cho tất cả các trò chơi trong hệ thống</Typography>
                                </Box>
                            </Box>

                                <form onSubmit={handleSubmit}>
                                    
                                    {/* ẨN LINK NHẠC BẰNG CSS */}
                                    <Box display="none">
                                        <input defaultValue={setting?.mp3} type="text" name="mp3" id="mp3" />
                                    </Box>

                                    <Grid container spacing={3}>
                                        
                                        {/* CỘT TRÁI: XỔ SỐ */}
                                        <Grid item xs={12} lg={8}>
                                            
                                            {/* XỔ SỐ MIỀN BẮC */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#F1416C', borderRadius: '4px'}}></Box> XỔ SỐ MIỀN BẮC
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label="Lô 2 số" name="mb_lo2" defaultValue={setting?.mb_lo2} />
                                                        <SettingInput label="Lô 2 số 1K" name="mb_lo2so1k" defaultValue={setting?.mb_lo2so1k} />
                                                        <SettingInput label="Lô 2 số đầu" name="mb_lo2dau" defaultValue={setting?.mb_lo2dau} />
                                                        <SettingInput label="Lô 3 số" name="mb_lo3" defaultValue={setting?.mb_lo3} />
                                                        <SettingInput label="Lô 4 số" name="mb_lo4" defaultValue={setting?.mb_lo4} />
                                                        <SettingInput label="Lô xiên 2" name="mb_loxien2" defaultValue={setting?.mb_loxien2} />
                                                        <SettingInput label="Lô xiên 3" name="mb_loxien3" defaultValue={setting?.mb_loxien3} />
                                                        <SettingInput label="Lô xiên 4" name="mb_loxien4" defaultValue={setting?.mb_loxien4} />
                                                        <SettingInput label="Đề đặc biệt" name="mb_dedb" defaultValue={setting?.mb_dedb} />
                                                        <SettingInput label="Đề đầu đặc biệt" name="mb_dedaudb" defaultValue={setting?.mb_dedaudb} />
                                                        <SettingInput label="Đề giải 7" name="mb_degiai7" defaultValue={setting?.mb_degiai7} />
                                                        <SettingInput label="Đề giải nhất" name="mb_de1" defaultValue={setting?.mb_de1} />
                                                        <SettingInput label="Đề đầu giải nhất" name="mb_dedau1" defaultValue={setting?.mb_dedau1} />
                                                        <SettingInput label="Đầu" name="mb_dau" defaultValue={setting?.mb_dau} />
                                                        <SettingInput label="Đuôi" name="mb_duoi" defaultValue={setting?.mb_duoi} />
                                                        <SettingInput label="3 càng đầu" name="mb_3cangdau" defaultValue={setting?.mb_3cangdau} />
                                                        <SettingInput label="3 càng đặc biệt" name="mb_3cangdb" defaultValue={setting?.mb_3cangdb} />
                                                        <SettingInput label="3 càng giải nhất" name="mb_3cang1" defaultValue={setting?.mb_3cang1} />
                                                        <SettingInput label="3 càng đầu đuôi" name="mb_3cangdauduoi" defaultValue={setting?.mb_3cangdauduoi} />
                                                        <SettingInput label="4 càng đặc biệt" name="mb_4cangdb" defaultValue={setting?.mb_4cangdb} />
                                                        <SettingInput label="Trượt xiên 4" name="mb_truotxien4" defaultValue={setting?.mb_truotxien4} />
                                                        <SettingInput label="Trượt xiên 8" name="mb_truotxien8" defaultValue={setting?.mb_truotxien8} />
                                                        <SettingInput label="Trượt xiên 10" name="mb_truotxien10" defaultValue={setting?.mb_truotxien10} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* XỔ SỐ MIỀN NAM */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#FFC700', borderRadius: '4px'}}></Box> XỔ SỐ MIỀN NAM
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label="Lô 2 số" name="mn_lo2" defaultValue={setting?.mn_lo2} />
                                                        <SettingInput label="Lô 2 số 1K" name="mn_lo2so1k" defaultValue={setting?.mn_lo2so1k} />
                                                        <SettingInput label="Lô 2 số đầu" name="mn_lo2dau" defaultValue={setting?.mn_lo2dau} />
                                                        <SettingInput label="Lô 3 số" name="mn_lo3" defaultValue={setting?.mn_lo3} />
                                                        <SettingInput label="Lô 4 số" name="mn_lo4" defaultValue={setting?.mn_lo4} />
                                                        <SettingInput label="Lô xiên 2" name="mn_loxien2" defaultValue={setting?.mn_loxien2} />
                                                        <SettingInput label="Lô xiên 3" name="mn_loxien3" defaultValue={setting?.mn_loxien3} />
                                                        <SettingInput label="Lô xiên 4" name="mn_loxien4" defaultValue={setting?.mn_loxien4} />
                                                        <SettingInput label="Đề đặc biệt" name="mn_dedb" defaultValue={setting?.mn_dedb} />
                                                        <SettingInput label="Đề đầu đặc biệt" name="mn_dedaudb" defaultValue={setting?.mn_dedaudb} />
                                                        <SettingInput label="Đề giải 7" name="mn_degiai7" defaultValue={setting?.mn_degiai7} />
                                                        <SettingInput label="Đề giải nhất" name="mn_de1" defaultValue={setting?.mn_de1} />
                                                        <SettingInput label="Đề đầu giải nhất" name="mn_dedau1" defaultValue={setting?.mn_dedau1} />
                                                        <SettingInput label="Đề đầu đuôi" name="mn_dedauduoi" defaultValue={setting?.mn_dedauduoi} />
                                                        <SettingInput label="Đầu" name="mn_dau" defaultValue={setting?.mn_dau} />
                                                        <SettingInput label="Đuôi" name="mn_duoi" defaultValue={setting?.mn_duoi} />
                                                        <SettingInput label="3 càng đầu" name="mn_3cangdau" defaultValue={setting?.mn_3cangdau} />
                                                        <SettingInput label="3 càng đặc biệt" name="mn_3cangdb" defaultValue={setting?.mn_3cangdb} />
                                                        <SettingInput label="3 càng giải nhất" name="mn_3cang1" defaultValue={setting?.mn_3cang1} />
                                                        <SettingInput label="3 càng đầu đuôi" name="mn_3cangdauduoi" defaultValue={setting?.mn_3cangdauduoi} />
                                                        <SettingInput label="4 càng đặc biệt" name="mn_4cangdb" defaultValue={setting?.mn_4cangdb} />
                                                        <SettingInput label="Trượt xiên 4" name="mn_truotxien4" defaultValue={setting?.mn_truotxien4} />
                                                        <SettingInput label="Trượt xiên 8" name="mn_truotxien8" defaultValue={setting?.mn_truotxien8} />
                                                        <SettingInput label="Trượt xiên 10" name="mn_truotxien10" defaultValue={setting?.mn_truotxien10} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* XỔ SỐ MIỀN TRUNG */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#50CD89', borderRadius: '4px'}}></Box> XỔ SỐ MIỀN TRUNG
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label="Lô 2 số" name="mt_lo2" defaultValue={setting?.mt_lo2} />
                                                        <SettingInput label="Lô 2 số 1K" name="mt_lo2so1k" defaultValue={setting?.mt_lo2so1k} />
                                                        <SettingInput label="Lô 2 số đầu" name="mt_lo2dau" defaultValue={setting?.mt_lo2dau} />
                                                        <SettingInput label="Lô 3 số" name="mt_lo3" defaultValue={setting?.mt_lo3} />
                                                        <SettingInput label="Lô 4 số" name="mt_lo4" defaultValue={setting?.mt_lo4} />
                                                        <SettingInput label="Lô xiên 2" name="mt_loxien2" defaultValue={setting?.mt_loxien2} />
                                                        <SettingInput label="Lô xiên 3" name="mt_loxien3" defaultValue={setting?.mt_loxien3} />
                                                        <SettingInput label="Lô xiên 4" name="mt_loxien4" defaultValue={setting?.mt_loxien4} />
                                                        <SettingInput label="Đề đặc biệt" name="mt_dedb" defaultValue={setting?.mt_dedb} />
                                                        <SettingInput label="Đề đầu đặc biệt" name="mt_dedaudb" defaultValue={setting?.mt_dedaudb} />
                                                        <SettingInput label="Đề giải 7" name="mt_degiai7" defaultValue={setting?.mt_degiai7} />
                                                        <SettingInput label="Đề giải nhất" name="mt_de1" defaultValue={setting?.mt_de1} />
                                                        <SettingInput label="Đề đầu giải nhất" name="mt_dedau1" defaultValue={setting?.mt_dedau1} />
                                                        <SettingInput label="Đề đầu đuôi" name="mt_dedauduoi" defaultValue={setting?.mt_dedauduoi} />
                                                        <SettingInput label="Đầu" name="mt_dau" defaultValue={setting?.mt_dau} />
                                                        <SettingInput label="Đuôi" name="mt_duoi" defaultValue={setting?.mt_duoi} />
                                                        <SettingInput label="3 càng đầu" name="mt_3cangdau" defaultValue={setting?.mt_3cangdau} />
                                                        <SettingInput label="3 càng đặc biệt" name="mt_3cangdb" defaultValue={setting?.mt_3cangdb} />
                                                        <SettingInput label="3 càng giải nhất" name="mt_3cang1" defaultValue={setting?.mt_3cang1} />
                                                        <SettingInput label="3 càng đầu đuôi" name="mt_3cangdauduoi" defaultValue={setting?.mt_3cangdauduoi} />
                                                        <SettingInput label="4 càng đặc biệt" name="mt_4cangdb" defaultValue={setting?.mt_4cangdb} />
                                                        <SettingInput label="Trượt xiên 4" name="mt_truotxien4" defaultValue={setting?.mt_truotxien4} />
                                                        <SettingInput label="Trượt xiên 8" name="mt_truotxien8" defaultValue={setting?.mt_truotxien8} />
                                                        <SettingInput label="Trượt xiên 10" name="mt_truotxien10" defaultValue={setting?.mt_truotxien10} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* XỔ SỐ SIÊU TỐC */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#1B84FF', borderRadius: '4px'}}></Box> XỔ SỐ SIÊU TỐC
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label="Lô 2 số" name="xsn_lo2" defaultValue={setting?.xsn_lo2} />
                                                        <SettingInput label="Lô 2 số 1K" name="xsn_lo2so1k" defaultValue={setting?.xsn_lo2so1k} />
                                                        <SettingInput label="Lô 2 số đầu" name="xsn_lo2dau" defaultValue={setting?.xsn_lo2dau} />
                                                        <SettingInput label="Lô 3 số" name="xsn_lo3" defaultValue={setting?.xsn_lo3} />
                                                        <SettingInput label="Lô 4 số" name="xsn_lo4" defaultValue={setting?.xsn_lo4} />
                                                        <SettingInput label="Lô xiên 2" name="xsn_loxien2" defaultValue={setting?.xsn_loxien2} />
                                                        <SettingInput label="Lô xiên 3" name="xsn_loxien3" defaultValue={setting?.xsn_loxien3} />
                                                        <SettingInput label="Lô xiên 4" name="xsn_loxien4" defaultValue={setting?.xsn_loxien4} />
                                                        <SettingInput label="Đề đặc biệt" name="xsn_dedb" defaultValue={setting?.xsn_dedb} />
                                                        <SettingInput label="Đề đầu đặc biệt" name="xsn_dedaudb" defaultValue={setting?.xsn_dedaudb} />
                                                        <SettingInput label="Đề giải 7" name="xsn_degiai7" defaultValue={setting?.xsn_degiai7} />
                                                        <SettingInput label="Đề giải nhất" name="xsn_de1" defaultValue={setting?.xsn_de1} />
                                                        <SettingInput label="Đề đầu giải nhất" name="xsn_dedau1" defaultValue={setting?.xsn_dedau1} />
                                                        <SettingInput label="Đầu" name="xsn_dau" defaultValue={setting?.xsn_dau} />
                                                        <SettingInput label="Đuôi" name="xsn_duoi" defaultValue={setting?.xsn_duoi} />
                                                        <SettingInput label="3 càng đầu" name="xsn_3cangdau" defaultValue={setting?.xsn_3cangdau} />
                                                        <SettingInput label="3 càng đặc biệt" name="xsn_3cangdb" defaultValue={setting?.xsn_3cangdb} />
                                                        <SettingInput label="3 càng giải nhất" name="xsn_3cang1" defaultValue={setting?.xsn_3cang1} />
                                                        <SettingInput label="3 càng đầu đuôi" name="xsn_3cangdauduoi" defaultValue={setting?.xsn_3cangdauduoi} />
                                                        <SettingInput label="4 càng đặc biệt" name="xsn_4cangdb" defaultValue={setting?.xsn_4cangdb} />
                                                        <SettingInput label="Trượt xiên 4" name="xsn_truotxien4" defaultValue={setting?.xsn_truotxien4} />
                                                        <SettingInput label="Trượt xiên 8" name="xsn_truotxien8" defaultValue={setting?.xsn_truotxien8} />
                                                        <SettingInput label="Trượt xiên 10" name="xsn_truotxien10" defaultValue={setting?.xsn_truotxien10} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                        </Grid>

                                        {/* CỘT PHẢI: MINI GAMES & TÙY CHỈNH KHÁC */}
                                        <Grid item xs={12} lg={4}>
                                            
                                            {/* THÔNG SỐ HỆ THỐNG CƠ BẢN */}
                                            <Card sx={{ backgroundColor: '#1E1E2D' }}>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#FFFFFF" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#50CD89', borderRadius: '4px'}}></Box> THÔNG SỐ HỆ THỐNG
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label={`${t("agent_rate")} (%)`} name="aff" defaultValue={setting?.aff} width={{xs: 12}} highlightColor="#50CD89" />
                                                        <SettingInput label={`Khuyến mãi nạp đầu (%)`} name="kmnapdau" defaultValue={setting?.kmnapdau} width={{xs: 12}} highlightColor="#50CD89" />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* TÀI XỈU */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#1B84FF', borderRadius: '4px'}}></Box> TÀI XỈU & TÀI XỈU MD5
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label={t("over")} name="tx_t" defaultValue={setting?.tx_t} width={{xs: 6}} />
                                                        <SettingInput label={t("under")} name="tx_x" defaultValue={setting?.tx_x} width={{xs: 6}} />
                                                        <SettingInput label={t("single")} name="tx_l" defaultValue={setting?.tx_l} width={{xs: 6}} />
                                                        <SettingInput label={t("double")} name="tx_c" defaultValue={setting?.tx_c} width={{xs: 6}} />
                                                        <Divider sx={{width: '100%', mt: 2, mb: 1}} />
                                                        <SettingInput label="MD5 TÀI" name="txmd5_t" defaultValue={setting?.txmd5_t} width={{xs: 6}} />
                                                        <SettingInput label="MD5 XỈU" name="txmd5_x" defaultValue={setting?.txmd5_x} width={{xs: 6}} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* XÓC ĐĨA */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#7239EA', borderRadius: '4px'}}></Box> XÓC ĐĨA
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label={t("single")} name="xd_le" defaultValue={setting?.xd_le} width={{xs: 6}} />
                                                        <SettingInput label={t("double")} name="xd_chan" defaultValue={setting?.xd_chan} width={{xs: 6}} />
                                                        <SettingInput label="3 Trắng 1 Đỏ" name="xd_3trang" defaultValue={setting?.xd_3trang} width={{xs: 6}} />
                                                        <SettingInput label="3 Đỏ 1 Trắng" name="xd_3do" defaultValue={setting?.xd_3do} width={{xs: 6}} />
                                                        <SettingInput label={t("4w")} name="xd_4trang" defaultValue={setting?.xd_4trang} width={{xs: 6}} />
                                                        <SettingInput label={t("4r")} name="xd_4do" defaultValue={setting?.xd_4do} width={{xs: 6}} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* CAT DOG (BẦU CUA) */}
                                            <Card>
                                                <CardContent sx={{ p: 3 }}>
                                                    <Typography variant="h6" fontWeight="800" color="#181C32" mb={3} display="flex" alignItems="center" gap={1}>
                                                        <Box sx={{width: '6px', height: '24px', backgroundColor: '#FFC700', borderRadius: '4px'}}></Box> TRÒ CHƠI CHÓ MÈO (BẦU CUA)
                                                    </Typography>
                                                    <Grid container spacing={2}>
                                                        <SettingInput label="Bật / Tắt Game (1/0)" name="cd_open" defaultValue={setting?.catdog?.open} isRed width={{xs: 12}} />
                                                        <SettingInput label={`Thưởng ${t("cat")}`} name="cd_thuong1" defaultValue={setting?.catdog?.thuong1} width={{xs: 6}} />
                                                        <SettingInput label={`Thưởng ${t("dog")}`} name="cd_thuong3" defaultValue={setting?.catdog?.thuong3} width={{xs: 6}} />
                                                        <SettingInput label="Thưởng Hòa" name="cd_thuong2" defaultValue={setting?.catdog?.thuong2} width={{xs: 6}} />
                                                        <SettingInput label={t("cat_jar")} name="cd_thuong4" defaultValue={setting?.catdog?.thuong4} width={{xs: 6}} />
                                                        <SettingInput label={t("dog_jar")} name="cd_thuong5" defaultValue={setting?.catdog?.thuong5} width={{xs: 6}} />
                                                    </Grid>
                                                </CardContent>
                                            </Card>

                                            {/* GREEDY (ĐƯỢC ẨN BẰNG CSS THEO YÊU CẦU GỐC CỦA KHÁCH) */}
                                            <Box sx={{ display: 'none' }}>
                                                <input defaultValue={setting?.greedy?.auto} type="number" name="auto" />
                                                <input defaultValue={setting?.greedy?.open} type="number" name="open" />
                                                <input defaultValue={setting?.greedy?.tyle1} type="number" name="tyle1" />
                                                <input defaultValue={setting?.greedy?.thuong1} type="number" name="thuong1" />
                                                <input defaultValue={setting?.greedy?.tyle2} type="number" name="tyle2" />
                                                <input defaultValue={setting?.greedy?.thuong2} type="number" name="thuong2" />
                                                <input defaultValue={setting?.greedy?.tyle3} type="number" name="tyle3" />
                                                <input defaultValue={setting?.greedy?.thuong3} type="number" name="thuong3" />
                                                <input defaultValue={setting?.greedy?.tyle4} type="number" name="tyle4" />
                                                <input defaultValue={setting?.greedy?.thuong4} type="number" name="thuong4" />
                                                <input defaultValue={setting?.greedy?.tyle5} type="number" name="tyle5" />
                                                <input defaultValue={setting?.greedy?.thuong5} type="number" name="thuong5" />
                                                <input defaultValue={setting?.greedy?.tyle6} type="number" name="tyle6" />
                                                <input defaultValue={setting?.greedy?.thuong6} type="number" name="thuong6" />
                                                <input defaultValue={setting?.greedy?.tyle7} type="number" name="tyle7" />
                                                <input defaultValue={setting?.greedy?.thuong7} type="number" name="thuong7" />
                                                <input defaultValue={setting?.greedy?.tyle8} type="number" name="tyle8" />
                                                <input defaultValue={setting?.greedy?.thuong8} type="number" name="thuong8" />
                                                <input defaultValue={setting?.greedy?.thuong9} type="number" name="thuong9" />
                                                <input defaultValue={setting?.greedy?.thuong10} type="number" name="thuong10" />
                                            </Box>

                                        </Grid>
                                    </Grid>

                                    {/* THANH LƯU CÀI ĐẶT CỐ ĐỊNH DƯỚI ĐÁY (STICKY) */}
                                    <Box sx={{ position: 'sticky', bottom: 20, zIndex: 10, mt: 4, display: 'flex', justifyContent: 'center' }}>
                                        <Button 
                                            type="submit" 
                                            variant="contained" 
                                            color="success" 
                                            startIcon={<SaveOutlined />}
                                            sx={{ 
                                                py: 1.5, px: 8, fontSize: '1.1rem', fontWeight: 800, borderRadius: '50px', 
                                                boxShadow: '0px 10px 30px rgba(80, 205, 137, 0.4)',
                                                transition: 'all 0.3s',
                                                '&:hover': { transform: 'translateY(-3px)', boxShadow: '0px 15px 40px rgba(80, 205, 137, 0.6)' }
                                            }}
                                        >
                                            {t("save")} TOÀN BỘ CÀI ĐẶT
                                        </Button>
                                    </Box>

                                </form>
                        

                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Setting;